import { motion } from 'framer-motion';

interface ScoreHealthRangeScoreIndicatorProps {
  isLoading: boolean;
  leftStyle: string;
  scoreDisplay: string;
}

/**
 * Renders an animated score indicator positioned horizontally along a range, displaying a styled score label and a vertical dashed line.
 *
 * Returns nothing if {@link isLoading} is true.
 *
 * @param leftStyle - CSS value specifying the horizontal position of the indicator.
 * @param scoreDisplay - Text to display inside the score label.
 */
export function ScoreHealthRangeScoreIndicator({
  isLoading,
  leftStyle,
  scoreDisplay,
}: ScoreHealthRangeScoreIndicatorProps) {
  if (isLoading) return null;

  return (
    <motion.div
      layout='position'
      style={{ left: leftStyle }}
      className="absolute z-10 flex flex-col bottom-[7px] items-center h-10"
      transformTemplate={(_, generatedTransform) => `${generatedTransform} translateX(-50%)`}
    >
      <div className="px-[6px] rounded-[10px] bg-palette-600 grid place-content-center h-5 min-h-5">
        <p className="text-xs leading-[normal] mt-[1px] font-bold text-palette-1100">{scoreDisplay}</p>
      </div>
      <svg
        width="2"
        height="26"
        fill="none"
        viewBox="0 0 2 26"
        className="text-palette-600 h-auto rotate-180 mt-[-2px]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 25L1 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 5" />
      </svg>
    </motion.div>
  );
}
